<template>
  <div class="Trio-body-wrapper Trio-body-center">
    <div class="Trio-content-row">
      <div class="Trio-afford">
        <form class="Trio-afford-form" v-on:submit.prevent>
          <div class="Trio-narrow-fields">
            <div class="Trio-form-group Trio-slider-group">
              <label for="field-1" class="Trio-label"
                >Ingresos netos mensuales</label
              >
              <!-- RANG -->
              <span class="Trio-field-wrapper">
                <input
                  @enter.prevent
                  min="100"
                  max="10000"
                  class="Trio-form-field"
                  v-model="income"
                  v-on:change="setIncome(income)"
                />
                <span class="Trio-unit">€</span>
              </span>
              <vue-slider
                :min="100"
                :max="10000"
                v-model="income"
                v-on:drag-end="setIncome(income)"
              ></vue-slider>
            </div>
            <div class="Trio-form-group Trio-slider-group">
              <label for="field-2" class="Trio-label"
                >Cantidad que aportas para la entrada</label
              >
              <!-- RANG -->
              <span class="Trio-field-wrapper">
                <input
                  @enter.prevent
                  type="number"
                  min="0"
                  max="600000"
                  class="Trio-form-field"
                  v-model="savings"
                  v-on:change="setSavings(savings)"
                />
                <span class="Trio-unit">€</span>
              </span>
              <vue-slider
                :min="100"
                :max="600000"
                v-model="savings"
                v-on:drag-end="setSavings(savings)"
              ></vue-slider>
            </div>
            <div class="Trio-form-group">
              <label for="field-3" class="Trio-label">Provincia</label>
              <v-select
                :options="locations"
                :reduce="(name) => name.province_id"
                label="name"
                name="province_id"
                id="field-6"
                :value="null"
                v-model="location"
                @input="setProvince"
                placeholder="Seleccionar provincia"
                v-validate="'required'"
              ></v-select>
            </div>
          </div>
        </form>
        <div class="Trio-afford-steps-col">
          <div
            :class="[
              'Trio-step-' +
                (changes.income + changes.savings + changes.province),
            ]"
            class="Trio-afford-steps"
          >
            <!-- inici sense el class amb numero, Trio-step-1, Trio-step-2, Trio-step-3 -->
            <div class="Trio-dots-wrapper">
              <i class="Trio-step-dot-3"></i>
              <i class="Trio-step-dot-1"></i>
              <i class="Trio-step-dot-2"></i>
              <i class="Trio-step-dot-3"></i>
            </div>
            <div class="Trio-dots-wrapper">
              <i class="Trio-step-dot-1"></i>
              <i class="Trio-step-dot-1"></i>
              <i class="Trio-step-dot-2"></i>
              <i class="Trio-step-dot-3"></i>
            </div>
            <div class="Trio-dots-wrapper">
              <i class="Trio-step-dot-1"></i>
              <i class="Trio-step-dot-2"></i>
              <i class="Trio-step-dot-2"></i>
              <i class="Trio-step-dot-3"></i>
            </div>
            <div class="Trio-stepper-text">
              <span class="Trio-steps-text"
                >{{
                  changes.income + changes.savings + changes.province
                }}/3</span
              >
              <span class="Trio-text">preguntas respuestas</span>
            </div>
          </div>
        </div>
      </div>
      <p v-if="errorText" class="Trio-error-form">* {{ errorText }}</p>
      <loader v-if="isLoading"></loader>
      <div v-else class="Trio-btn-row">
        <button-next
          :is-disabled="!next || isLoading"
          v-on:clicked="showResults()"
        >
          Calcular
        </button-next>
      </div>
    </div>
  </div>
</template>

<script>
import buttonNext from "../components/buttonNext";
import affordHeader from "./affordHeader.vue";
import { Store } from "../store/index.js";
import locationService from "../services/location";
import Cleave from "vue-cleave-component";
import loader from "./loader.vue";

/* eslint-disable */

export default {
  name: "affordSetData",
  components: { affordHeader, buttonNext, Cleave, loader },
  props: {
    errorText: null,
    isLoading: false,
  },
  data: function () {
    return {
      next: false,
      changes: {
        income: 0,
        savings: 0,
        province: 0,
      },
      options: {
        numeral: true,
        numeralDecimalMark: ",",
        delimiter: ".",
      },
    };
  },
  created() {
    if (Store.getters["locations/locations"] === null) {
      locationService
        .getLocations()
        .then((res) => {
          Store.commit("locations/SET_LOCATIONS", res);
        })
        .catch((err) => console.error(err));
    }
    if (Store.getters["affordData/income"] === null) this.income = 2920;
    if (Store.getters["affordData/savings"] === null) this.savings = 102000;
  },
  computed: {
    step() {
      return Store.getters["ui/step"];
    },
    savings: {
      get() {
        const savings = Store.getters["affordData/savings"];
        if (savings) {
          this.changes.savings = 1;
        }
        return savings;
      },
      set(savings) {
        Store.commit("affordData/SET_SAVINGS", savings);
      },
    },
    income: {
      get() {
        const income = Store.getters["affordData/income"];
        if (income) {
          this.changes.income = 1;
        }
        return income;
      },
      set(income) {
        Store.commit("affordData/SET_INCOME", income);
      },
    },
    locations: {
      get() {
        return Store.getters["locations/locations"] || [];
      },
      set(locations) {
        Store.commit("locations/SET_LOCATIONS", locations);
      },
    },
    location: {
      get() {
        const province_id = Store.getters["affordData/provinceId"];
        if (province_id) {
          this.changes.province = 1;
          this.next = true;
        }
        return province_id;
      },
      set(provinceId) {
        Store.commit("affordData/SET_PROVINCE_ID", provinceId);
      },
    },
  },
  methods: {
    showResults() {
      this.$emit("updateAfford");
    },
    setIncome: function (income) {
      this.changes.income = 1;
      this.income = parseInt(income); // replace non-digits
    },
    setSavings: function (savings) {
      this.changes.savings = 1;
      this.savings = parseInt(savings); // replace non-digits
    },
    setProvince: function (province) {
      this.changes.province = 1;
      this.next = true;
      Store.commit("affordData/SET_PROVINCE_ID", province);
    },
  },
};
</script>